// src/pages/exercise/data/exercisePool.js
// Static exercise data embedded from Mood2Move Exercise Pool CSV.
// moodMatch is a normalised array — multi-value CSV cells are split here.

export const exercisePool = [
  {
    id: "bball001",
    name: "Drop-in Basketball",
    description:
      "Full-court basketball game where you join ongoing pickup or start your own team, focusing on defense, passing, and continuous cardio intervals.",
    trainingType: "cardio",
    moodMatch: ["BunnyEnergetic"],
    weather: ["indoor"],
    level: "advanced",
    equipment: "rental-free",
    duration: "30min",
    intensity: "high",
    location: "ubc-recnorth",
    groupType: "group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "bball002",
    name: "Basketball Solo Shooting Drills",
    description:
      "Individual shooting session using spot-up shots, free throws, and three-point routines with light jogging between spots to keep your heart rate up.",
    trainingType: "skill",
    moodMatch: ["Sloth Calm"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "rental-free",
    duration: "10min",
    intensity: "moderate",
    location: "ubc-recnorth",
    groupType: "solo, partner",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "walk001",
    name: "MoveU Walking Tour",
    description:
      "Guided campus walk from Main Mall to Rose Garden via Botanical Garden. Slow pace with stops for stretching and mindfulness cues.",
    trainingType: "cardio",
    moodMatch: ["Tiger Resilient", "Sloth Calm"],
    weather: ["outdoor-sunny", "outdoor-rain", "outdoor-cold"],
    level: "beginner",
    equipment: "none",
    duration: "30min",
    intensity: "low",
    location: "ubc-campus",
    groupType: "group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "walk002",
    name: "Rose Garden Sunset Walk",
    description:
      "Easy walk from the Nest along Main Mall to the Rose Garden viewpoint, pausing to look over the water and do light stretching at the railing.",
    trainingType: "cardio",
    moodMatch: ["Tiger Resilient", "Sloth Calm"],
    weather: ["outdoor-sunny"],
    level: "beginner",
    equipment: "none",
    duration: "10min",
    intensity: "low",
    location: "ubc-campus",
    groupType: "solo, partner, group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "walk003",
    name: "Wreck Beach Stairs Walk",
    description:
      "Moderate-paced walk to Wreck Beach, descend partway or all the way and climb back up at a comfortable pace, focusing on steady breathing and leg endurance.",
    trainingType: "endurance",
    moodMatch: ["BunnyEnergetic", "Tiger Resilient"],
    weather: ["outdoor-sunny", "outdoor-cold"],
    level: "intermediate",
    equipment: "none",
    duration: "45min",
    intensity: "moderate",
    location: "ubc-wreckbeach",
    groupType: "solo, partner, group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "run001",
    name: "Main Mall Jog 2–3 km",
    description:
      "Easy out-and-back jog along Main Mall from the Nest towards the Rose Garden and back, flat pavement route ideal for beginners building aerobic base.",
    trainingType: "cardio",
    moodMatch: ["BunnyEnergetic", "Tiger Resilient", "Moose Motivated"],
    weather: ["outdoor-sunny", "outdoor-cold"],
    level: "intermediate",
    equipment: "none",
    duration: "10min",
    intensity: "moderate",
    location: "ubc-campus",
    groupType: "solo, partner, group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "yoga001",
    name: "Drop-in Yoga",
    description:
      "Vinyasa flow yoga in Nest Birdcoop. 60-min instructor-led session covering flexibility, balance, and breath work.",
    trainingType: "endurance",
    moodMatch: ["Sloth Calm", "Tiger Resilient"],
    weather: ["indoor"],
    level: "intermediate",
    equipment: "none",
    duration: "30min",
    intensity: "low",
    location: "ubc-fitnessgym",
    groupType: "solo, partner, group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "swim001",
    name: "Lane Swimming",
    description:
      "50m pool lap swimming. Freestyle, breaststroke, or backstroke. Low-impact full-body cardio.",
    trainingType: "cardio",
    moodMatch: ["BunnyEnergetic", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "none",
    duration: "30min",
    intensity: "moderate",
    location: "ubc-campus",
    groupType: "solo, partner, group",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "stretch001",
    name: "Stretch & Mobility",
    description:
      "30-min full-body stretching routine combining static holds and dynamic movements.",
    trainingType: "endurance",
    moodMatch: ["Tiger Resilient", "Sloth Calm"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "none",
    duration: "10min",
    intensity: "low",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "",
    fittIntensity: "",
    fittTime: "",
    fittType: "",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "lowerbody001",
    name: "Squat Jumps",
    description:
      "4 sets × 8 reps, 30–45s rest. Stand feet shoulder-width, drop into a squat, then explode upward as high as possible, land softly and go straight into the next rep.",
    trainingType: "power",
    moodMatch: ["Tiger Resilient", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "moderate",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "4x/week",
    fittIntensity: "moderate",
    fittTime: "10min",
    fittType: "power",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "lowerbody002",
    name: "Isometric Wall Sit to Explosive Stand",
    description:
      "4 sets × 5 reps, 45s rest. Hold a wall sit for 5s, then drive up to standing as fast as possible — the contrast between the hold and the explosive stand trains rate of force development.",
    trainingType: "power",
    moodMatch: ["Tiger Resilient", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "moderate",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "moderate",
    fittTime: "10min",
    fittType: "power",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "lowerbody003",
    name: "Reverse Lunges",
    description:
      "3 sets × 10–12 reps/side, 45s rest. From standing, step one foot back and lower your rear knee toward the floor in a controlled motion, return to standing, and alternate sides.",
    trainingType: "strength",
    moodMatch: ["Tiger Resilient", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "moderate",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "moderate",
    fittTime: "10min",
    fittType: "strength",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "upperbody001",
    name: "Incline Push-Ups (Wall or Desk)",
    description:
      "3 sets × 10–15 reps, 45s rest. Place hands on a wall or desk edge at chest height, perform a push-up with a straight body line — lower with control and press back up.",
    trainingType: "strength",
    moodMatch: ["BunnyEnergetic", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "low",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "low",
    fittTime: "10min",
    fittType: "strength",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "upperbody002",
    name: "Tricep Dips",
    description:
      "3 sets × 10–15 reps, 45s rest. Grip the edge of a sturdy chair or desk behind you, legs extended or bent, lower your body by bending the elbows to ~90° then press back up through the palms.",
    trainingType: "strength",
    moodMatch: ["BunnyEnergetic", "Moose Motivated"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "low",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "low",
    fittTime: "10min",
    fittType: "strength",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "upperbody003",
    name: "Prone Y-T-W Raises",
    description:
      "3 sets × 8 reps each shape, 30s rest. Lie face-down with arms extended, lift into a Y shape, hold 2s, lower — repeat forming a T, then a W, targeting rear deltoids and mid-traps.",
    trainingType: "endurance",
    moodMatch: ["Sloth Calm", "Tiger Resilient"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "low",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "low",
    fittTime: "10min",
    fittType: "endurance",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
  {
    id: "core001",
    name: "Dead Bug",
    description:
      "3 sets × 8–10 reps/side, 30s rest. Lie on your back, extend arms toward the ceiling and bring knees to 90°, slowly lower opposite arm and leg toward the floor while keeping your lower back pressed flat, return and alternate.",
    trainingType: "endurance",
    moodMatch: ["Sloth Calm", "Tiger Resilient"],
    weather: ["indoor"],
    level: "beginner",
    equipment: "bodyweight",
    duration: "10min",
    intensity: "moderate",
    location: "dorm-room, ubc-fitnessgym",
    groupType: "solo",
    fittFrequency: "3x/week",
    fittIntensity: "moderate",
    fittTime: "10min",
    fittType: "endurance",
    evidenceSource: "",
    evidenceUrl: "",
    videoUrl: "",
    imageUrl: "",
  },
];